const CCTreatmentPlan = () => {
	return (
		<>
			<path
				d="M18.45 27.81H1.53997C0.879966 27.81 0.339966 27.27 0.339966 26.6V5.60996C0.339966 4.93996 0.879966 4.39996 1.53997 4.39996H18.45C19.11 4.39996 19.65 4.93996 19.65 5.60996V26.61C19.65 27.28 19.11 27.82 18.45 27.82V27.81ZM1.53997 5.39996C1.42997 5.39996 1.33997 5.48996 1.33997 5.60996V26.61C1.33997 26.72 1.42997 26.82 1.53997 26.82H18.45C18.56 26.82 18.65 26.73 18.65 26.61V5.60996C18.65 5.49996 18.56 5.39996 18.45 5.39996H1.53997Z"
				fill="#002D55"
			/>
			<path
				d="M12.68 2.84999H11.79C11.82 2.72999 11.83 2.59999 11.83 2.46999C11.83 1.48999 11.01 0.679993 9.99002 0.679993C8.97002 0.679993 8.15002 1.47999 8.15002 2.46999C8.15002 2.59999 8.16002 2.72999 8.19002 2.84999H7.30002C6.04002 2.84999 5.02002 3.84999 5.02002 5.06999V6.30999L14.96 6.29999V5.06999C14.96 3.84999 13.93 2.84999 12.68 2.84999Z"
				fill="#BADDF4"
			/>
			<path
				d="M5.01001 6.80999C4.73001 6.80999 4.51001 6.58999 4.51001 6.30999V5.06999C4.51001 3.56999 5.76001 2.34999 7.29001 2.34999H7.64001C7.70001 1.13999 8.73001 0.179993 9.98001 0.179993C11.23 0.179993 12.26 1.13999 12.32 2.34999H12.68C14.21 2.34999 15.45 3.56999 15.45 5.06999V6.29999C15.45 6.57999 15.23 6.79999 14.95 6.79999C14.95 6.79999 5.05001 6.80999 5.01001 6.80999ZM7.30001 3.34999C6.32001 3.34999 5.52001 4.11999 5.52001 5.06999V5.80999H14.46V5.06999C14.46 4.11999 13.66 3.34999 12.68 3.34999H11.79C11.64 3.34999 11.49 3.27999 11.4 3.15999C11.31 3.03999 11.27 2.87999 11.3 2.73999C11.32 2.64999 11.33 2.55999 11.33 2.46999C11.33 1.75999 10.73 1.17999 9.99001 1.17999C9.25001 1.17999 8.65001 1.75999 8.65001 2.46999C8.65001 2.55999 8.65001 2.65999 8.68001 2.73999C8.71001 2.88999 8.68001 3.03999 8.58001 3.15999C8.49001 3.27999 8.34001 3.34999 8.19001 3.34999H7.30001Z"
				fill="#002D55"
			/>
			<path
				d="M10 17.41C12.21 17.41 14 15.62 14 13.41C14 11.2 12.21 9.40997 10 9.40997C7.79 9.40997 6 11.2 6 13.41C6 15.62 7.79 17.41 10 17.41Z"
				fill="#BADDF4"
			/>
			<path
				d="M9.46001 15.29C9.33001 15.29 9.20001 15.24 9.10001 15.14L7.72001 13.74C7.53001 13.54 7.53001 13.23 7.72001 13.03C7.92001 12.84 8.23001 12.84 8.43001 13.03L9.43001 14.05L11.51 11.69C11.69 11.48 12.01 11.46 12.22 11.65C12.43 11.83 12.45 12.15 12.26 12.36L9.82001 15.12C9.73001 15.22 9.60001 15.29 9.46001 15.29Z"
				fill="#002D55"
			/>
			<path
				d="M16.3101 20.86H3.69006C3.41006 20.86 3.19006 20.64 3.19006 20.36C3.19006 20.08 3.41006 19.86 3.69006 19.86H16.3101C16.5901 19.86 16.8101 20.08 16.8101 20.36C16.8101 20.64 16.5901 20.86 16.3101 20.86Z"
				fill="#002D55"
			/>
			<path
				d="M15 23.8H5C4.72 23.8 4.5 23.58 4.5 23.3C4.5 23.02 4.72 22.8 5 22.8H15C15.28 22.8 15.5 23.02 15.5 23.3C15.5 23.58 15.28 23.8 15 23.8Z"
				fill="#002D55"
			/>
		</>
	);
};

export default CCTreatmentPlan;
